require('./impromptu');
let Url = require('domurl');

jQuery(function() {
    $(document).on('click', '.js-city-select', function(e) {
        e.preventDefault();
        var citiesHtml = $('.js-city-list-container').html();
        $.prompt(citiesHtml, {
            buttons: {},
            persistent: false, //чтобы можно было закрыть при клике по оверлею
            classes: {
                prompt: 'prompt--middle-large',
                form: 'prompt__form-special',
                close: 'jqiclose--cross'
            }
        });
    });

    $(document).on('click', '.cities-list__link', function() {
        let currentUrl = new Url();
        if (currentUrl.query.city) {
            delete currentUrl.query.city;
            $(this).attr('href', currentUrl.toString());
        }
        var date = new Date(new Date().getTime() + 99999999);
        document.cookie =
            'BITRIX_SM_region_code=' + $(this).data('code') + '; expires=' + date.toUTCString() + '; path=/';

        const urlSetRegion = '/ajax/action/region_widget/set_region/';
        const xhr = new XMLHttpRequest();
        xhr.open('GET', urlSetRegion, false);
        xhr.send();
        if (xhr.status !== 200) {
            console.error(urlSetRegion + ' ' + xhr.statusText);
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-cities.js